import { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AdminLayout from "../layout/AdminLayout";
import Dashboard from "../pages/Dashboard";
import ProductCategories from "../pages/ProductCategories";
import ProductTypes from "../pages/ProductTypes";
import Brands from "../pages/Brands";
import Subcategories from "../pages/Subcategories";
import Products from "../pages/Products";
import Subscribers from "../pages/Subscribers";
import AdminBookDemo from "../pages/AdminBookDemo";
import AdminRegionsPage from "../pages/AdminRegionsPage";
import Orders from "../pages/AdminOrders";
import Payments from "../pages/AdminPayments";
import AdminReviews from "../pages/AdminReviews";
import AdminServices from "../pages/AdminServices";
import AdminSoftware from "../pages/AdminSoftware";
import AdminAbout from "../pages/AdminAbout";
import AdminCareerP1 from "../pages/AdminCareerP1";
import AdminCareerApplications from "../pages/AdminCareerApplications";
import AdminLatestNews from "../pages/AdminLatestNews";
import AdminTestimonials from "../pages/AdminTestimonials";
import AdminTeam from "../pages/AdminTeam";
import AdminFooter from "../pages/AdminFooter";
import SiteSearch from "../pages/SiteSearch";
import UserGroups from "../pages/UserGroups";
import UsersPage from "../pages/UsersPage";
import AdminPromotions from "../pages/settings/AdminPromotions";
import AdminDiscountVouchers from "../pages/settings/AdminDiscountVouchers";
import AlgorithmSetup from "../pages/settings/AlgorithmSetup";
import PromotionBanners from "../pages/settings/PromotionBanners";
import SendCampaign from "../pages/settings/SendCampaign";
import EmailTemplates from "../pages/settings/EmailTemplates";
import EmailBodies from "../pages/settings/EmailBody";
import EmailBodyEditor from "../pages/settings/EmailBodyEditor";
import EmailVariables from "../pages/settings/EmailVariables";
import SMTPSettings from "../pages/settings/SMTPSettings";
import PaymentGateways from "../pages/settings/PaymentGateways";
import AdminPolicies from "../pages/settings/AdminPolicies";
import AdminPolicyEditor from "../pages/settings/AdminPolicyEditor";
import UserRights from "../pages/UserRights";
import PublicEmails from "../pages/settings/PublicEmails";
import AdminSupportTickets from "../pages/support/AdminSupportTickets";
import AdminSupportTicketDetail from "../pages/support/AdminSupportTicketDetail";
import AuditTrail from "../pages/AuditTrail";

export default function AdminRoutes() {
  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("admin_user") || "null");

    if (storedUser?.tokenExpiry && Date.now() > storedUser.tokenExpiry) {
      localStorage.removeItem("admin_user");
      window.location.href = "/admin/login"; // or your route
    }
  }, []);

  return (
    <Routes>
      <Route element={<AdminLayout />}>
        <Route index element={<Dashboard />} />
        <Route path="categories" element={<ProductCategories />} />
        <Route path="types" element={<ProductTypes />} />
        <Route path="/brands" element={<Brands />} />
        <Route path="subcategories" element={<Subcategories />} />
        <Route path="products" element={<Products />} />
        <Route path="subscribers" element={<Subscribers />} />
        <Route path="demo-bookings" element={<AdminBookDemo />} />
        <Route path="regions" element={<AdminRegionsPage />} />
        <Route path="orders" element={<Orders />} />
        <Route path="reviews" element={<AdminReviews />} />
        <Route path="testimonials" element={<AdminTestimonials />} />
        <Route path="team" element={<AdminTeam />} />
        <Route path="footer" element={<AdminFooter />} />
        <Route path="services" element={<AdminServices />} />
        <Route path="software" element={<AdminSoftware />} />
        <Route path="about" element={<AdminAbout />} />
        <Route path="admin-career" element={<AdminCareerP1 />} />
        <Route
          path="career-applications"
          element={<AdminCareerApplications />}
        />
        <Route path="news" element={<AdminLatestNews />} />
        <Route path="site-search" element={<SiteSearch />} />
        <Route path="payments" element={<Payments />} />
        <Route path="groups" element={<UserGroups />} />
        <Route path="user-rights" element={<UserRights />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="promotions" element={<AdminPromotions />} />
        <Route path="discount-vouchers" element={<AdminDiscountVouchers />} />
        <Route path="algorithm" element={<AlgorithmSetup />} />
        <Route path="banners" element={<PromotionBanners />} />
        <Route path="send-campaign" element={<SendCampaign />} />
        <Route path="public-emails" element={<PublicEmails />} />
        <Route path="emails" element={<EmailTemplates />} />
        <Route path="email-bodies" element={<EmailBodies />} />
        <Route path="email-bodies/create" element={<EmailBodyEditor />} />
        <Route path="email-bodies/edit/:id" element={<EmailBodyEditor />} />
        <Route path="email-variables" element={<EmailVariables />} />
        <Route path="smtp-settings" element={<SMTPSettings />} />
        <Route path="payment-gateways" element={<PaymentGateways />} />
        <Route path="policies" element={<AdminPolicies />} />
        <Route path="policies/create" element={<AdminPolicyEditor />} />
        <Route path="policies/edit/:id" element={<AdminPolicyEditor />} />
        <Route path="support-tickets" element={<AdminSupportTickets />} />
        <Route
          path="support-tickets/:id"
          element={<AdminSupportTicketDetail />}
        />
        <Route path="auditTrail" element={<AuditTrail />} />
      </Route>

      <Route path="*" element={<Navigate to="/admin" />} />
    </Routes>
  );
}
